// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
export function useRootBackLink() {
    var _a = useState(""), backLink = _a[0], setBackLink = _a[1];
    var _b = useParams(), tenantId = _b.tenantId, eventId = _b.eventId;
    useEffect(function () {
        if (!tenantId || !eventId) {
            setBackLink("/");
        }
        else {
            setBackLink("/tenant/".concat(tenantId, "/event/").concat(eventId));
        }
    }, [eventId, tenantId]);
    return backLink;
}
